import { createSlice } from '@reduxjs/toolkit';

import { selectPlanAndProceed } from '@/store/new-order/actions/planSelect';

export const STEPS = {
  plans: 'plan',
  paymentMethods: 'methods',
  cardForm: 'cardForm',
  success: 'success',
  successWithDownload: 'successWithDownload',
  successForAppUser: 'successForAppUser',
  successForPremiumAppUser: 'successForPremiumAppUser',
} as const;

type PossibleStep = (typeof STEPS)[keyof typeof STEPS];

export interface StepsState {
  current: PossibleStep;
}
const initialState: StepsState = {
  current: STEPS.plans,
};

export const stepsSlice = createSlice({
  name: 'steps',
  initialState,
  reducers: {
    switchToPaymentMethodsStep: (state) => {
      state.current = STEPS.paymentMethods;
    },
    switchToPlansStep: (state) => {
      state.current = STEPS.plans;
    },
    switchToCardFormStep: (state) => {
      state.current = STEPS.cardForm;
    },
    switchToSuccessStep: (state) => {
      state.current = STEPS.success;
    },
    switchToSuccessStepWithDownload: (state) => {
      state.current = STEPS.successWithDownload;
    },
    switchToSuccessStepForAppUser: (state) => {
      state.current = STEPS.successForAppUser;
    },
    switchToSuccessStepForPremiumAppUser: (state) => {
      state.current = STEPS.successForPremiumAppUser;
    },
  },
  extraReducers(builder) {
    builder.addCase(selectPlanAndProceed, (state) => {
      state.current = STEPS.paymentMethods;
    });
  },
});

export const {
  switchToPaymentMethodsStep,
  switchToPlansStep,
  switchToCardFormStep,
  switchToSuccessStep,
  switchToSuccessStepWithDownload,
  switchToSuccessStepForAppUser,
  switchToSuccessStepForPremiumAppUser,
} = stepsSlice.actions;
